export default __webpack_public_path__ + "static/media/man1.444a1bf7.jpg";